<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="filter_enable" class="col-sm-2 control-label">HABILITAR:</label>
            <div class="col-sm-2">
                <select v-model="config.filter_enable" class="form-control" id="filter_enable">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                </select>
            </div>
            <label for="filter_value" class="col-sm-2 control-label">VALOR</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.filter_value"  class="form-control" id="filter_value" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Bus} from '../../../../class/bus';
    import {X3tech} from "../../../../class/x3tech";
    export default {
        name: "ApnConcox",
        props: {
            config: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await X3tech.sendFiltro(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
